<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import type { HomeDashboardResponse } from "../../../../../../../../../../api/kehrblatt/home-dashboard"
  import OpenTasksSection from "./_modules/open-tasks-section"

  const {
    tasks,
    inboxPath,
    onOpenInbox,
    onRetry,
    showOpenTasks = true,
  }: {
    tasks: HomeDashboardResponse["tasks"]
    inboxPath?: string | null
    onOpenInbox?: (() => void) | null
    onRetry: () => void
    showOpenTasks?: boolean
  } = $props()
</script>

<div class="home-dashboard">
  {#if showOpenTasks && tasks.state === "ERROR"}
    <div class="dashboard-error" role="alert">
      <span>Die offenen Aufgaben konnten nicht geladen werden.</span>
      <CTA
        type="secondaryButton"
        small={true}
        content="Erneut laden"
        darkMode={false}
        onClick={onRetry}
      />
    </div>
  {/if}

  {#if showOpenTasks && tasks.state === "READY" && tasks.data}
    <OpenTasksSection
      tiles={tasks.data.task_tiles}
      loading={false}
      disabled={!inboxPath}
      {onOpenInbox}
    />
  {/if}

</div>

<style lang="less">
  .home-dashboard {
    display: flex;
    flex-direction: column;
    gap: 1.4rem;
  }

  .dashboard-error {
    border: 1px solid color-mix(in srgb, var(--warning-100, #e07a00) 44%, transparent);
    background: color-mix(in srgb, var(--warning-100, #e07a00) 9%, transparent);
    color: var(--text-invers-100);
    padding: 0.85rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
  }
</style>
